<template>
    <div class="frmkedvezmenyezettek_formcont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>
        <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>


        <div style="width:100%; box-sizing: border-box; text-align: left; margin:0px 0px 20px 0px;" v-show="(InitDone)&&(LIST.length>0)">
            <span @click="PrintTagsagiOkirat" class="cms_linkbutton cms_linkbutton_GREEN_FULL" style="padding-left:20px; padding-right: 20px;">
                <i class="fal fa-file-pdf" style="margin-right:8px; vertical-align: middle; font-size: 22px; line-height: 22px;"></i>
                <span style="font-weight: 500; font-size: 15px; line-height: 15px; vertical-align: middle;">Tagsági okirat</span>
            </span>
        </div>

        <div class="frmkedvezmenyezettek_cont" v-show="(InitDone)&&(LIST.length>0)">
            <div v-for="(item, index) in LIST" :key="index" class="frmkedvezmenyezettek_item">
                <div class="frmkedvezmenyezettek_itemcol1">
                    <b>{{item.Nev}}</b>
                    <span v-show="item.SzuletesiNev!=''"><br><i>({{item.SzuletesiNev}})</i></span>
                    <br>Született: {{item.Szuletett}}
                    <br>Anyja neve: {{item.AnyjaNeve}}
                </div>
                <div class="frmkedvezmenyezettek_itemcol2">
                    Adóazon. jel: {{item.Adoazon}}
                    <br>{{item.Cim}}
                    <br>Részarány: <b>{{item.Reszarany}}</b>
                </div>
            </div>
        </div>


        <div class="frmkedvezmenyezettek_cont" v-show="(InitDone)&&(LIST.length==0)" v-html="infotext_nincs_rekord">

        </div>



    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'


export default {
  name: 'frmkedvezmenyezettek',
  components: {
      GrcText,
      GrcNum,
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCheckboxMobile,
      GrcDocDisplayer
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmkedvezmenyezettek_",

          InitDone:false,  
          LIST:[],

          infotext_nincs_rekord:"",

      }
  },
  model: {

  },  
  methods:{

    async PrintTagsagiOkirat()
    {
        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };


        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "GetReport", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        var docb64 = Q.RESULT[0].DocData;
        var docfn = Q.RESULT[0].FajlNev;
        var docdfn = ""; // display fájlnév, ha üres, akkor az eredeti lesz, kiterjesztést ponttal együtt hozzáfűzi


        //console.log(Q);
        //return;

        var docresult = this.$refs.DocDisplayer.ShowFile(docb64, docfn, docdfn);
        // grcmain_ShowFile(docb64, docfn, docdfn);

        if (docresult != "")
        {
            this.ShowResult(docresult, 200);
        }

    },

    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        //await this.$refs.Dialog.Alert("Információ",pText).then(res => { DialogResult = res; });  
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });               
    },


    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmkedvezmenyezettek", pCompName);
    },

    SetLang()
    {
        this.infotext_nincs_rekord = this.GetTextBookItem("infotext_nincs_rekord");
        this.Init();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },

      async Init()
      {
        this.InitDone = false;

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "init", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.LIST = Q.RESULT;

        this.InitDone = true;

      },

    async ShowLoginError(pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", pText).then(res => { DialogResult = res; });
        
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();
    
  }

}


</script>


